import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromHarness from '@fc-store/reducers/harness.reducer';

export const getHarnessState = createFeatureSelector<fromHarness.State>(
  fromHarness.harnessFeatureKey,
);

export const getAllHarnessList = createSelector(
  getHarnessState,
  fromHarness.getHarnessList,
);

export const getHarnessById = (id: number) =>
  createSelector(getAllHarnessList, (harness) =>
    harness.find((h) => h.id === id),
  );
